var _line, _line2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 794,
    height: 795,
    viewBox: "0 0 794 795",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 221.355,
    y1: 570.062,
    x2: 672.703,
    y2: 118.715,
    stroke: "#EE0000",
    strokeWidth: 58,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 602.707,
    y1: 568.719,
    x2: 223,
    y2: 189.011,
    stroke: "#EE0000",
    strokeWidth: 58,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M606.154 60.6781C448.889 -37.7834 247.18 -14.5356 115.897 116.746C-38.6325 271.276 -38.6325 523.584 115.897 678.114C193.162 755.379 295.043 794.353 396.239 794.353C497.436 794.353 599.316 755.379 676.581 678.114C808.547 546.148 831.111 343.755 731.966 186.49C723.761 173.499 706.667 169.396 693.675 177.601C680.684 185.806 676.581 202.9 684.786 215.892C770.256 351.276 750.427 524.952 636.923 638.456C504.274 771.105 287.521 771.105 154.872 638.456C22.2222 505.806 22.2222 289.054 154.872 156.405C268.376 43.5841 441.368 23.755 576.752 107.858C589.744 116.063 606.838 111.96 615.043 98.9687C623.248 85.9772 619.145 68.8832 606.154 60.6781Z",
    fill: "#4A4A4A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/Failed.28356f8b62ade4b54164666a0264bee5.svg";
export { ForwardRef as ReactComponent };